import React from 'react';
import PropTypes from 'prop-types';
import sxPropType from 'propTypes/sx';
import { Pagination as MuiPagination, PaginationItem, paginationItemClasses } from '@mui/material';

import getBoundarySettings from 'components/Pagination/helpers/getBoundarySettings';
import PaginationLink from 'components/Pagination/PaginationLink';
import { styled } from '@mui/material/styles';

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  [`&.${paginationItemClasses.previousNext}`]: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  [`&.${paginationItemClasses.page}`]: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
  [`&.${paginationItemClasses.selected}`]: {
    color: theme.palette.dark.text,
  },
}));

const Pagination = ({ className, numberOfPages, currentPageIndex, path, sx }) => {
  const { siblingCount, boundaryCount } = getBoundarySettings(currentPageIndex, numberOfPages);
  const hidePaginationButtons = numberOfPages <= 5;
  const secondToLastPageItem = numberOfPages - 1;

  // This is a hack to fulfill product requirement unsupported by the pagination library.
  const hidePageItem = (page) => {
    if (numberOfPages < 5) {
      return false;
    }
    return page === secondToLastPageItem && currentPageIndex === 3;
  };

  return (
    <MuiPagination
      sx={sx}
      className={className}
      color="primary"
      page={currentPageIndex}
      count={numberOfPages}
      hideNextButton={hidePaginationButtons}
      hidePrevButton={hidePaginationButtons}
      siblingCount={siblingCount}
      boundaryCount={boundaryCount}
      renderItem={(item) =>
        hidePageItem(item.page) ? null : (
          <StyledPaginationItem
            component={PaginationLink}
            path={path}
            // copied disabled to isDisabled otherwise the prop will be excluded from our custom link component
            isDisabled={item.disabled}
            pageIndex={item.page}
            currentPageIndex={currentPageIndex}
            {...item}
          />
        )
      }
    />
  );
};

Pagination.propTypes = {
  className: PropTypes.string,
  numberOfPages: PropTypes.number.isRequired,
  currentPageIndex: PropTypes.number.isRequired,
  path: PropTypes.string.isRequired,
  sx: sxPropType,
};

Pagination.defaultProps = {
  className: null,
  sx: {},
};

export default Pagination;
